export default __webpack_public_path__ + "static/media/1682.03b8f4d6.png";